module.exports = __webpack_public_path__ + "media/My-Virtual-Convention by SYNTHES'3D.8d6e0e39.mp4";